import { render } from "./ListRequestPhonePage.vue?vue&type=template&id=5d132db8&ts=true"
import script from "./ListRequestPhonePage.vue?vue&type=script&lang=ts"
export * from "./ListRequestPhonePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__